import { IGetAllNovosNegociosArquivoUseCase } from "../../../presentation/useCases/read/get_all_novos_negocios_arquivo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { NovosNegociosArquivoLista } from "../../models/novos_negocios_arquivo_lista";

/**
 * GetAllNovosNegociosArquivoUseCase
 */

export class GetAllNovosNegociosArquivoUseCase
  extends BasePaginatedUseCase<NovosNegociosArquivoLista>
  implements IGetAllNovosNegociosArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    idNovosNegocios: number,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllNovosNegociosArquivoLista(
      idNovosNegocios,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
